module.exports = __webpack_public_path__ + "img/Noemi_Leon.f03f9770.jpg";